import gql from 'graphql-tag';

export const SEARCH_EQUIPMENTS_QUERY = gql`
  query EquipmentsQuery (
    $where: EquipmentWhereInput
    $orderBy: EquipmentOrderByInput
    $limit: Int
    $offset: Int
  ) {
    equipments (where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        name
        number
        notes
        archived
        imageUrl
        type {
          id
          name
        }
        location {
          id
        }
        locationSector {
          id
        }
        locationEnvironment {
          id
        }
      }
    }
  }
`;
export const SEARCH_EQUIPMENTS_WITH_WARRANTIES_QUERY = gql`
  query EquipmentsQuery (
    $where: EquipmentWhereInput
    $orderBy: EquipmentOrderByInput
    $limit: Int
    $offset: Int
  ) {
    equipments (where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        name
        number
        notes
        archived
        imageUrl
        type {
          id
          name
        }
        location {
          id
        }
        locationSector {
          id
        }
        locationEnvironment {
          id
        }
        warranties {
          id
          name
          status
          coverageDurationDays
          extendedCoverageDurationDays
          extendedValue
          endDate
          startDate
          extendedEndDate
          value
          description
          archived
          createdAt
          updatedAt
          equipment {
            id
            name
          }
          maintenance {
            id
            number
          }
          template {
            id
            name
          }
          createdBy {
            id
            name
          }
          updatedBy {
            id
            name
          }
          companies {
            id
          }
          maintenancesTypes {
            id
            name
          }
        }
        warrantySummary {
          id
          status
          startDate
          endDate
          extendedEndDate
        }
      }
    }
  }
`;

export const GET_EQUIPMENT_QUERY = gql`
  query EquipmentQuery(
    $id: ID!
  ) {
    equipment(id: $id) {
      id
      name
      number
      archived
      imageUrl
      location {
        id
      }
      locationSector {
        id
      }
      locationEnvironment {
        id
      }
    }
  }
`;

export const CREATE_EQUIPMENT_MUTATION = gql`
  mutation CreateEquipmentMutation($input: CreateEquipmentInput!) {
    createEquipment (input: $input) {
      id
    }
  }
`;

export const UPDATE_EQUIPMENT_MUTATION = gql`
  mutation UpdateEquipmentMutation($input: UpdateEquipmentInput!) {
    updateEquipment (input: $input) {
      id
    }
  }
`;

export const ARCHIVE_EQUIPMENT_MUTATION = gql`
  mutation ArchiveEquipmentMutation($id: ID!) {
    archiveEquipment(id: $id) {
      id
    }
  }
`;

export const UNARCHIVE_EQUIPMENT_MUTATION = gql`
  mutation UnarchiveEquipmentMutation($id: ID!) {
    unarchiveEquipment(id: $id) {
      id
    }
  }
`;

export const LINK_EQUIPMENT_LINK_MUTATION = gql`
  mutation linkEquipmentToLocationSectorAndEnvironment($input: LinkEquipmentToLocationSectorAndEnvironmentInput!) {
    linkEquipmentToLocationSectorAndEnvironment(input: $input) {
      id
    }
  }
`;
